import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import InventarioTarifariosGrid from './InventarioTarifariosGrid.jsx';
import InventarioTarifariosAbm from './InventarioTarifariosAbm.jsx';

/**
 * VEC-3499 — Tarifarios (listas de precios por proveedor).
 *
 * Independiente del Inventario v3.0: flag propio (tarifarios.habilitado), permisos
 * propios (TARIFARIOS_*) y endpoints propios (/inventario/tarifarios). Cubre el listado, el ABM
 * con proveedores, los precios por ítem, la importación/exportación y el historial.
 */
const InventarioTarifarios = ({ match }) => {
  return (
    <div className="content-wrapper">
      <div className="content-header row">
        <div className="content-header-left col-md-6 col-12 mb-2">
          <h3 className="content-header-title">
            <FormattedMessage id="inventarioTarifarios.header_tarifarios" defaultMessage="Tarifarios" />
          </h3>
        </div>
      </div>
      <div className="content-body">
        <Switch>
          <Route exact path={`${match.url}`} render={(props) => <InventarioTarifariosGrid {...props} />} />
          <Route exact path={`${match.url}/add`} render={(props) => <InventarioTarifariosAbm {...props} action="ADD" />} />
          <Route exact path={`${match.url}/:id`} render={(props) => <InventarioTarifariosAbm {...props} action="VIEW" />} />
          <Route exact path={`${match.url}/:id/edit`} render={(props) => <InventarioTarifariosAbm {...props} action="EDIT" />} />
        </Switch>
      </div>
    </div>
  );
};

export default withRouter(InventarioTarifarios);
